import LinkWithIcon from "@vfuk/core-link-with-icon";

const ReturnStep = ({
  displayText,
  onBack,
}: {
  displayText?: string;
  onBack: () => void;
}) => {
  return (
    <LinkWithIcon
      appearance="secondary"
      text={displayText || ""}
      icon={{
        name: "arrow-left",
        justify: "left",
      }}
      size={3}
      onClick={onBack}
    />
  );
};

export default ReturnStep;
